import React from "react";
import {Modal, Select, Box, Button, SpaceBetween, SelectProps} from "@amzn/awsui-components-react/polaris";
import {useEffect} from "react";
import {GenerateReportRequest} from "src/models/reports/GenerateReport";
import GenerateReportsModal from "src/components/reports/GenerateReportsModal";
import {accountingDaysList} from "src/models/reports/GetAccountingDayList"
import useLocalStorage from "src/utils/useLocalStorage";
import TPEErrorWatcher from 'src/components/shared/TPEErrorWatcher';
import ServiceCollection from "src/services/ServiceCollection";
import CONSTANTS, { IS_TESTED_PARTY_REPORT_ENABLED } from "src/utils/constants";

export default function TPTaxFilterReportModal(props: {
    visible: boolean,
    onClose: () => void,
    reportName: string,
    workbookList?: SelectProps.Option[],
    companyCodeList?: SelectProps.Option[],
    periodList: SelectProps.Option[],
    reportHeader: string,
    services: ServiceCollection,
    isRestricted?: boolean 

}) {
    const {visible, onClose: onModalClose, reportName, workbookList,companyCodeList, periodList, reportHeader, isRestricted = false} = props;
    const [showGenerateReportsModal, setShowGenerateReportsModal] = React.useState(false);
    const [reportId, setReportId] = React.useState(null as unknown as string);
    const [selectedPeriodOption, setSelectedPeriodOption] = React.useState(null as unknown as SelectProps.Option|null);
    const [selectedWorkbookIdOption, setSelectedWorkbookIdOption] = React.useState(null as unknown as SelectProps.Option|null);
    const [selectedCompanyCodeOption, setSelectedCompanyCodeOption] = React.useState(null as unknown as SelectProps.Option|null);
    const [selectedAccountingDayOption, setSelectedAccountingDayOption] = React.useState(null as unknown as SelectProps.Option|null);
    const [generateReportRequest, setGenerateReportRequest] = React.useState(null as unknown as GenerateReportRequest);
    const [generateReportResponse, generateReportLoading, generateReportError] = props.services.reportsService.generateReport(generateReportRequest);
    // Check if the current date is within the restricted period (first 10 days of the month)
    const isDisabled = isRestricted && new Date().getDate() <= 10;

    useEffect(() => {
        if (!generateReportResponse) {
            return;
        }
        setReportId(generateReportResponse.reportId);
        setShowGenerateReportsModal(true);
    }, [generateReportResponse])

    return (<>
            <Modal
                onDismiss={onModalClose}
                visible={visible}
                closeAriaLabel="Close modal"
                footer={
                    <Box float="right">
                        <SpaceBetween direction="horizontal" size="xs">
                            <Button variant="link" data-class = {"saveButton createReportCancelButton"} onClick={onModalClose}>Cancel</Button>
                            <Button variant="primary" data-class = "saveButton createReportButton" disabled={!selectedPeriodOption || 
                                                                                               !!generateReportLoading ||  
                                                                                               !selectedAccountingDayOption || 
                                                                                               (!!workbookList && !selectedWorkbookIdOption) ||
                                                                                               (!!companyCodeList && !selectedCompanyCodeOption) ||
                                                                                               isDisabled
                                                                                            }
                                    disabledReason={isDisabled ? "The action is disabled for the first 10 days of month" : ""}
                                    onClick={() => {
                                        setGenerateReportRequest({
                                            userId: useLocalStorage.getUsernameFromLocalStorage(),
                                            reportName: reportName,
                                            params: {
                                                period: selectedPeriodOption?.value as string,
                                                accountingDay: selectedAccountingDayOption?.value as string,
                                                workbookId: selectedWorkbookIdOption?.value as string,
                                                ...(IS_TESTED_PARTY_REPORT_ENABLED
                                                    && reportName === CONSTANTS.REPORT_TYPES.TP_TAX_LEF_REPORT
                                                    ? { testedPartyCompanyCode: selectedCompanyCodeOption?.value as string }
                                                    : { providerCompanyCode: selectedCompanyCodeOption?.value as string })
                                            }
                                        });
                                        setSelectedPeriodOption(null);
                                        setSelectedAccountingDayOption(null);
                                        setSelectedWorkbookIdOption(null);
                                        setSelectedCompanyCodeOption(null);
                                    }}>{generateReportLoading ? 'Creating Report...' : 'Create Report'}</Button>
                        </SpaceBetween>
                    </Box>
                }
                header={reportHeader}
            >
            <SpaceBetween direction="vertical" size="xs">
                <Select data-class = "basicModalDropdown periodDropDown"
                    selectedOption={selectedPeriodOption}
                    options={periodList}
                    onChange={({detail}) => {
                        setSelectedPeriodOption(detail.selectedOption);
                    }}
                    selectedAriaLabel="Selected"
                    placeholder="Select Period"
                />
                <Select data-class = "basicModalDropdown accountingDayDropDown"
                    selectedOption={selectedAccountingDayOption}
                    options={accountingDaysList}
                    onChange={({detail}) => {
                        setSelectedAccountingDayOption(detail.selectedOption);
                    }}
                    selectedAriaLabel="Selected"
                    placeholder="Select Accounting Day"
                />
                {workbookList && 
                    <Select data-class = "basicModalDropdown workbookListDropDown"
                    selectedOption={selectedWorkbookIdOption}
                    options={workbookList}
                    onChange={({detail}) => {
                        setSelectedWorkbookIdOption(detail.selectedOption);
                    }}
                    loadingText="Loading Workbooks List"
                    filteringType="auto"
                    filteringPlaceholder="Search Workbook Name"
                    selectedAriaLabel="Selected"
                    placeholder="Select Workbook Id"
                />

                }
                {companyCodeList && 
                    <Select data-class = "basicModalDropdown companyCodeListDropdown"
                    selectedOption={selectedCompanyCodeOption}
                    options={companyCodeList}
                    onChange={({detail}) => {
                        setSelectedCompanyCodeOption(detail.selectedOption);
                    }}
                    loadingText="Loading Company Codes"
                    filteringType="auto"
                    filteringPlaceholder="Search Company Code"
                    selectedAriaLabel="Selected"
                    placeholder="Select Company Code"
                />

                }
            </SpaceBetween>
            <TPEErrorWatcher services={props.services} errors={[generateReportError]} />
            </Modal>

            <GenerateReportsModal
                visible={showGenerateReportsModal}
                onClose={() =>{
                    onModalClose();
                    setShowGenerateReportsModal(false);
                }}
                reportId={reportId}
            />
        </>
    );
}